import { render, staticRenderFns } from "./PinnacleDesert.vue?vue&type=template&id=d404c4e6&"
import script from "./PinnacleDesert.vue?vue&type=script&lang=js&"
export * from "./PinnacleDesert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports